import React from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import FirstPage from "./FirstPage";
import Table from "../../components/pdf/table";

const PeopleCountReport = ({
    footfallFilter,
    buildingName,
    start,
    end,
    peopleCountTableData,
    roomNameList,
    roomPeopleFlowLinks,
    totalPeopleFlowLink,
}) => {
    Font.register({
        family: "NotoSansTC",
        src: "/fonts/NotoSansTC-Regular.ttf",
    });

    const styles = StyleSheet.create({
        page: {
            flexDirection: "column",
            backgroundColor: "#FFFFFF",
            padding: 40,
            lineHeight: 1.5,
            fontSize: 14,
        },
        gap: {
            height: 20,
        },
        sectionTitle: {
            fontSize: 18,
            fontFamily: "Helvetica-Bold",
            marginTop: 5,
            marginBottom: 5,
        },
        visualHeader: {
            fontSize: 14,
            fontFamily: "Helvetica-Bold",
            textAlign: "center",
        },
    });

    const headerData = [
        {
            columnName: "Rank",
            columnKey: "Rank",
            columnStyle: {},
            handleClick: null,
        },
        {
            columnName: "Room",
            columnKey: "Room",
            columnStyle: {},
            handleClick: null,
        },
        {
            columnName: "Cumulative Count",
            columnKey: "Cumulative Count",
            columnStyle: {},
            handleClick: null,
        },
    ];
    return (
        <Document title="CBM Smart Toilet System Report" pageLayout="oneColumn">
            <FirstPage reportName={"Footfall"} buildingName={buildingName} start={start} end={end} />
            <Page size="A4" style={styles.page}>
                <View>
                    <Text style={styles.sectionTitle} id="people-count">
                        Footfall{" "}
                    </Text>

                    <Text style={styles.visualHeader}>Footfall distribution accumulated over selected period</Text>
                    <Text style={styles.visualHeader}>
                        {`(highlighting the top ${footfallFilter} highest footfalls)`}
                    </Text>

                    {roomPeopleFlowLinks.map((l, i) => {
                        return (
                            <View key={l} wrap={false}>
                                <Text>　</Text>
                                <Image src={l}></Image>
                                <View style={styles.gap} />
                            </View>
                        );
                    })}
                    <View wrap={false}>
                        <Text style={styles.visualHeader}>Total footfall for all toilets</Text>
                        <Image src={totalPeopleFlowLink} />
                        <View style={styles.gap} />
                    </View>
                </View>
            </Page>
            <Page wrap>
                <Text style={[styles.visualHeader, { marginTop: "20px" }]}>Footfall summary</Text>
                <View
                    style={[
                        {
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                    ]}
                >
                    <Table addStyle={{ width: "80%", marginTop: "20px" }}>
                        <Table.Thead headerData={headerData} fontSize={"10px"} widthArray={[1, 5, 3]} />
                        <Table.Tbody
                            headerData={headerData}
                            fontSize={"10px"}
                            widthArray={[1, 5, 3]}
                            contentData={peopleCountTableData}
                            breakArray={[31, 34]}
                            breakStyle={{ marginTop: "20px" }}
                        />
                    </Table>
                </View>
            </Page>
        </Document>
    );
};

export default PeopleCountReport;
